import store from '~/store'

export default (to, from, next) => {
  if (store.getters['auth/check']) {
    //next({ name: 'project.select' })
    next({ name: 'group.select' })
  } else {
    next()
  }
}
